import { IconTrashXFilled } from '@tabler/icons-react';

export default function DeleteIconCircle({ onClick, size = 40, solid = false }) {
  return (
    <button
      type="button"
      aria-label="Eliminar artículo"
      title="Eliminar artículo"
      className={`flex items-center justify-center shrink-0 rounded-full border-none cursor-pointer touch-manipulation select-none transition-all duration-200 ease-out active:scale-[0.95] ${
        solid
          ? '[@media(hover:hover)]:hover:brightness-110'
          : '[@media(hover:hover)]:hover:bg-[rgba(255,69,58,0.16)]'
      }`}
      style={{
        backgroundColor: solid ? '#ff453a' : 'rgba(255, 69, 58, 0.1)',
        boxShadow: solid
          ? '0 6px 18px rgba(255, 69, 58, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.18)'
          : 'none',
        width: `${size}px`,
        height: `${size}px`,
      }}
      onClick={onClick}
    >
      <IconTrashXFilled size={solid ? 17 : 16} color={solid ? '#fff' : '#ff453a'} />
    </button>
  );
}
